import { render, staticRenderFns } from "./StatGrid.vue?vue&type=template&id=a5929c8a&scoped=true&"
import script from "./StatGrid.vue?vue&type=script&lang=js&"
export * from "./StatGrid.vue?vue&type=script&lang=js&"
import style0 from "./StatGrid.vue?vue&type=style&index=0&id=a5929c8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5929c8a",
  null
  
)

export default component.exports